import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import ShoppingCart from '../../../models/ShoppingCart';
import ShoppingCartActions from '../../../actions/ShoppingCartActions';
import ShoppingCartStore from '../../../stores/ShoppingCartStore';
import styles from './index.sass';

const ENTER_KEY = 13;

class CouponCodeForm extends React.Component {
  static contextTypes = {
    executeAction : React.PropTypes.func
  }

  static propTypes = {
    shoppingCart: React.PropTypes.instanceOf(ShoppingCart),
  }

  constructor(props) {
    super(props);

    this.state = {
      shoppingCart: props.shoppingCart,
      couponCode: props.shoppingCart.coupon_code || '',
      store: props.store,
      editCoupon: false,
      meetsCouponCriteria: true,
      helpText: '',
      loading: false
    };
  }

  componentWillReceiveProps(nextProps) {
    let hasValidCouponCode = ((this.state.shoppingCart.coupon_code != nextProps.shoppingCart.coupon_code)
                              || (this.state.couponCode == nextProps.shoppingCart.coupon_code));
    let editCoupon = true;
    let helpText = '';
    if ((hasValidCouponCode && !nextProps.shoppingCart.has_expired_coupon) || this.state.couponCode === "") {
      editCoupon = false;
    } else if (hasValidCouponCode && nextProps.shoppingCart.has_expired_coupon) {
      helpText = <div className={styles.helpText}>Coupon Code is expired</div>;
    } else if (!this.state.loading && !hasValidCouponCode) {
      helpText = <div className={styles.helpText}>Coupon Code is invalid</div>;
    }
    this.setState({
      editCoupon: editCoupon,
      helpText: helpText,
      loading: false,
      shoppingCart: nextProps.shoppingCart,
      store: nextProps.store
    });
  }

  submitCouponCode(e) {
    this.checkIfValidCouponCode(this.state.couponCode);
  }

  handleOnChange(e) {
    let couponCode = e.target.value.trim();
    this.setState({couponCode: couponCode});
  }

  handleOnBlur(e) {
    if (this.hasValidCoupon()) {
      this.setState({
        editCoupon: false
      });
    }
  }

  handleOnFocus(e) {
    if (this.state.helpText != '') {
      this.setState({helpText: ''});
    }
  }

  handleKeyDown(e) {
    if (e.keyCode === ENTER_KEY && !this.state.loading) {
      this.submitCouponCode(e);
    }
  }

  toggleFormShow(e) {
    this.setState({
      editCoupon: !(this.state.editCoupon),
    });
  }

  checkIfValidCouponCode(couponCode) {
    this.setState({loading: true});
    this.context.executeAction(ShoppingCartActions.setCouponCode, {
      coupon_code: couponCode,
      store_id: this.props.shoppingCart.store.id,
    });
  }

  hasValidCoupon() {
    return ((this.state.couponCode == this.props.shoppingCart.coupon_code) && this.props.shoppingCart.coupon_code != '');
  }

  handleOnClickCouponCode() {
    this.setState({editCoupon: true});
  }

  renderForm() {
    let { couponCode, editCoupon } = this.state;

    let className = `${styles.input} ${styles.typing}`;
    if (this.state.helpText != '') {
      className = `${styles.input} ${styles.invalid}`;
    }

    return (
      <div>
        <input className={className}
          autoFocus
          placeholder="Coupon Code"
          type="text"
          onChange={this.handleOnChange.bind(this)}
          onBlur={this.handleOnBlur.bind(this)}
          onFocus={this.handleOnFocus.bind(this)}
          onKeyUp={this.handleKeyDown.bind(this)}
          value={couponCode} />
          <button className={styles.updateButton} onClick={this.submitCouponCode.bind(this)}>
            Apply
          </button>
          {this.state.helpText}
      </div>
    );
  }

  renderButton() {
    return(
      <button className={styles.couponCodeText} onClick={this.toggleFormShow.bind(this)}>
        Have a coupon code?
      </button>
    );
  }

  render() {
    let { couponCode, editCoupon, hasValidCoupon, shoppingCart } = this.state;

    if (this.hasValidCoupon() && !editCoupon) {
      let couponCodeProps = {
        className : styles.couponCode,
        onClick   : this.handleOnClickCouponCode.bind(this)
      };
      let inputProps = {
        className : styles.checkbox,
        type      : 'checkbox',
        checked   : true
      };
      let labelProps = {
        className : styles.checkboxLabel
      };
      let marketingMessageClassName = (!!shoppingCart.promotion && shoppingCart.promotion.applied) ? styles.couponCodeMessage : styles.couponCodeHelpText;
      return (
        <div {...couponCodeProps}>
          <input {...inputProps} />
          <label {...labelProps}>
            <span className={styles.couponCodeTitle}>{shoppingCart.coupon_code}</span>
            <p className={marketingMessageClassName}>{shoppingCart.promotion ? shoppingCart.promotion.marketing_message : ''}</p>
          </label>
        </div>
      );
    }
    if (editCoupon) {
      return this.renderForm();
    } else {
      return this.renderButton();
    }
  }
}

export default CouponCodeForm;



// WEBPACK FOOTER //
// banquet/components/ShoppingCartContents/CouponCodeForm/index.js